module.exports = __webpack_public_path__ + "static/media/bucket.cc7d0a4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/self-help/bucket.png
// module id = 915
// module chunks = 2